export const DEFAULT_CENTER = { latitude: 55.7558, longitude: 37.6173 };
export const CHILD_ZOOM = 16;
export const MIN_ZOOM = 3;
export const LIST_ZOOM = 12;
export const DEFAULT_RANGE = 100;
export const MARKER_HEIGHT = 58;
export const MARKER_HEIGHT_ACTIVE = 85;
export const MARKER_WIDTH = 50;
export const MARKER_WIDTH_ACTIVE = 74;
export const MAP_OPTIONS = {
  fullscreenControl: false,
  mapTypeControl: false,
  streetViewControl: false,
  minZoom: MIN_ZOOM,
};
export const AUTOSUGGEST_ZOOM = 16;
